import { Link } from "react-router-dom";
export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--sand)" }}>
      <div className="card-warm p-10 text-center max-w-md">
        <h1 className="font-serif-display text-3xl font-semibold" style={{ color: "var(--pine)" }}>Paiement annulé</h1>
        <p className="mt-3 text-[var(--muted-text)]">Aucun montant n'a été prélevé. Vous pouvez recommencer quand vous voulez.</p>
        <Link to="/mon-espace" className="btn-primary mt-6 inline-flex">Retour</Link>
      </div>
    </div>
  );
}
